export function defaultBanner(): string {
    return 'https://res.cdn.office.net/assets/eventify/themeImages/Large/PBP_Banner.jpg';
}
